module.exports = __webpack_public_path__ + "img/et2.401fec21.png";